import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { WebApp as App } from './app';

import '@servicetitan/anvil2/assets/css-utils/a2-utils.css';
import '@ionic/react/css/core.css';
/*
 * for ionic react components
 * import '@ionic/react/css/normalize.css'; //Affects anvil button
 */
import '@ionic/react/css/structure.css';
// styles for ui components
import '@servicetitan/web-feature-ui/styles.css';
// font styles
import '@servicetitan/web-feature-ui/typography.css';
// overrides for anvil
import '@servicetitan/web-feature-ui/anvil.overrides.css';

import { setupIonicReact } from '@ionic/react';

setupIonicReact();

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

const root = createRoot(appContainer);

root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
